/**
 * Collapsible component that can be reused.
 *
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module components/subpages/collapsible.jsx
 * @class Collapsible
 * @since 0.7.11
 */

import React, {Component} from 'react';
import {IconButton} from '@rmwc/icon-button';

class Collapsible extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        };
    }

    render() {
        const
            props = this.props,
            translate = this.props.translate,
            data = props.data,
            open = this.state.open;
        return (
            <div className={props.wrapper}>
                <div className={props.header}>
                    <span>{translate.t(data.title)}</span>
                    <IconButton
                        icon="keyboard_arrow_down"
                        onClick={() => this.setState({open: !open})}
                        onIcon="keyboard_arrow_up" />
                </div>
                <div className={open ? '' : props.content}>
                    {data.content.map((linkData, index) => <p key={index}><a className={linkData.class} href={linkData.link} rel="noopener noreferrer" target="_blank">{translate.t(linkData.text)}</a></p>)}
                </div>
            </div>
        );
    }
}

export default Collapsible;
